import { PaymentMethod } from '@typings'

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  bank_transfer: 'Bankoverschrijving',
  cash: 'Contant',
  card: 'Pin/Creditcard',
  other: 'Anders',
}

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'bank_transfer', label: 'Bankoverschrijving' },
  { value: 'cash', label: 'Contant' },
  { value: 'card', label: 'Pin/Creditcard' },
  { value: 'other', label: 'Anders' },
] as const

export const PAYMENT_LABELS = {
  TITLE: 'Betaling registreren',
  AMOUNT: 'Bedrag',
  PAYMENT_DATE: 'Betaaldatum',
  PAYMENT_METHOD: 'Betaalwijze',
  REFERENCE: 'Referentie',
  NOTES: 'Notities',
  SAVE: 'Betaling opslaan',
  CANCEL: 'Annuleren',
  DELETE: 'Verwijderen',
  EDIT: 'Bewerken',
  PAID: 'Betaald',
  OUTSTANDING: 'Openstaand',
  PARTIAL: 'Gedeeltelijk betaald',
  PAYMENT_HISTORY: 'Betalingshistorie',
  NO_PAYMENTS: 'Nog geen betalingen geregistreerd',
  RECORD_PAYMENT: 'Registreer betaling',
  DELETE_CONFIRM: 'Weet je zeker dat je deze betaling wilt verwijderen?',
  DELETE_SUCCESS: 'Betaling verwijderd',
  SAVE_SUCCESS: 'Betaling opgeslagen',
  UPDATE_SUCCESS: 'Betaling bijgewerkt',
}
